import { httpClient } from '../api/http.client';
import { LoginDto, LoginResponse, ChangePasswordDto, ChangePasswordResponse } from '@/domain/entities';
import { setAuthToken } from '../config/api.config';

export class AuthRepository {
  async login(credentials: LoginDto): Promise<LoginResponse> {
    const response = await httpClient.post<LoginResponse>(
      '/api/admin/auth/login',
      credentials
    );
    setAuthToken(response.token);
    return response;
  }

  logout(): void {
    setAuthToken('');
  }

  async changePassword(data: ChangePasswordDto): Promise<ChangePasswordResponse> {
    return await httpClient.post<ChangePasswordResponse>(
      '/api/admin/auth/change-password',
      data
    );
  }
}

export const authRepository = new AuthRepository();

